import React from 'react';
import { Link } from 'react-router-dom';
import { RENAISSANCE_COLORS } from '../utils';

const NotFound: React.FC = () => {
    return (
        <div style={{ 
            height: '100vh', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            backgroundColor: RENAISSANCE_COLORS.beige, 
        }}>
            <div className="not-found" style={{ textAlign: 'center' }}>
                <h1>404 - Not Found</h1>
                <p>Sorry, the page you are looking for does not exist.</p>
                <Link to="/">Go to Home</Link>
            </div>
        </div>
    );
};

export default NotFound;
